import React, { Component } from 'react';
import { Formik } from 'formik';
import { getErrMsg, cmsGetAdminInvitationRoles, cmsUpdateAdminUserPromise } from '../CallMSAPI.js';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { SubmitButton } from '../FormHelpers';
import { connect } from 'react-redux';
var _ = require('lodash');


class EditAdminUserForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            apiRolesLoaded: false,
            apiRoles: []
        };

        this.getFormDefaults = this.getFormDefaults.bind(this);
    }

    componentDidMount(e) {
        var self = this;

        cmsGetAdminInvitationRoles(
            self.props.account.Id,
            function (callmsData) {
                self.setState({
                    apiRoles: callmsData.Results,
                    apiRolesLoaded: true
                });
            },
            function (error) {
                toast.error("Roles error: " + error);
            }
        );
    }

    getFormDefaults() {
        var self = this;

        var baseDefaults = {
            RoleIds: []
        };

        if (this.state.apiRolesLoaded) {
            if (this.props.adminUser && this.props.adminUser.RoleIds) {
                baseDefaults["RoleIds"] = this.state.apiRoles.filter(function (r) {
                    return self.props.adminUser.RoleIds.indexOf(r.Id) !== -1
                });
            }
        }

        return baseDefaults;
    }

    clear = (resetForm) =>
    {
        resetForm();
        this.props.closeForm();
    }

    render() {
        var self = this;

        if (!this.state.apiRolesLoaded) {
            return (
                <div className="admin-inviteForm">
                    Loading resources...
                </div>
            );
        }

        return (
            <Formik
                // Required so updates from getFormDefaults get propagated down to form
                enableReinitialize={true}
                initialValues={this.getFormDefaults()}
                validate={values => {
                    let errors = {};
                    // Ensure at least one role is set
                    if (!values["RoleIds"] || values["RoleIds"].length === 0) {
                        errors["RoleIds"] = "You must select at least one role";
                    }
                    return errors;
                }}
                onSubmit={(originalValues, { setSubmitting, setErrors, resetForm }) => {
                    // var formik = this;

                    var values = _.cloneDeep(originalValues);

                    values["RoleIds"] = [].slice
                        .call(values["RoleIds"])
                        .map(option => option.Id);

                    cmsUpdateAdminUserPromise(
                        self.props.account.Id,
                        self.props.adminUser.Id,
                        values
                    ).then(function () {

                        // Keep the form open for now after saves
                        toast.success("Admin user successfully updated");

                        self.props.userUpdateTrigger && self.props.userUpdateTrigger();

                        self.props.closeForm();
                    }, function (err) {
                        toast.error("Unable to update user: " + getErrMsg(err));
                    }).finally(function () {
                        setSubmitting(false);
                    })
                }}
            >

                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    resetForm
                    /* and other goodies */
                }) => {


                    // Make list of roles
                    var roles = null;
                    if (this.state.apiRolesLoaded === true) {
                        roles = (
                            <Select
                                name="RoleIds"
                                options={this.state.apiRoles}
                                className="select-dropdown"
                                // You need to set the new field value
                                onChange={function (opt) {
                                    setFieldValue("RoleIds", opt);
                                }}
                                value={values["RoleIds"]}
                                isMulti
                                getOptionLabel={option => option.Name}
                                getOptionValue={option => option.Id}
                            />
                        );
                    }

                    return (
                        <div className="inner-table-wrapper">
                            <form role="form" className="form update-admin-invite-form form-inline" onSubmit={handleSubmit}>
                                <fieldset disabled={isSubmitting}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Roles</label>
                                            {roles}
                                            <span className="error-message">{errors.RoleIds && touched.RoleIds && errors.RoleIds}</span>
                                        </div>


                                        <div className="col-md-12">
                                            <div className="admin-user-form-action-buttons">
                                                <SubmitButton type='submit' className={"btn btn-primary pull-right"} isSubmitting={isSubmitting}> Update Roles </SubmitButton>
                                                <button type='button' className="btn btn-default" onClick={() => this.clear(resetForm)}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    )
                }
                }

            </Formik>
        );
    }
}
const mapStateToProps = state => {
    const account = state.account;
    return {
        account: account.account
    };
}
const mapDispatchToProps = (_dispatch) => {
    return {

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditAdminUserForm);
